import { render, staticRenderFns } from "./change-language-header-table.vue?vue&type=template&id=3537c6fd&scoped=true"
import script from "./change-language-header-table.vue?vue&type=script&lang=js"
export * from "./change-language-header-table.vue?vue&type=script&lang=js"
import style0 from "./change-language-header-table.vue?vue&type=style&index=0&id=3537c6fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537c6fd",
  null
  
)

export default component.exports